import { Typography } from '@mui/material'; 
import { useTheme,Theme } from '@mui/material/styles';
import React from 'react';

interface IProps {
  text: string;
}

const useStyles =  (theme:Theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[200],
  },
});

// A unified placeholder
export const Placeholder = ({ text }: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme); 

  return (
    <div className={classes.root}>
      <Typography>{text}</Typography>
    </div>
  );
};
